// @flow

import * as React from 'react'

type Props = {
  status?: 'success' | 'warning' | 'error' | 'default' | 'in_progress',
  size?: 'small' | 'medium' | 'large',
  hidden?: boolean,
  className?: string,
}

const StatusBall = ({
  status = 'default',
  size = 'small',
  hidden = false,
  className,
}: Props): React.Node => {
  let statusColor
  const sizeClass =
    size === 'small'
      ? 'w-2.5 h-2.5'
      : size === 'medium'
        ? 'w-3.5 h-3.5'
        : 'w-5 h-5'

  switch (status) {
    case 'success':
      statusColor = 'bg-green-400'
      break
    case 'warning':
      statusColor = 'bg-yellow-400'
      break
    case 'error':
      statusColor = 'bg-red-400'
      break
    case 'in_progress':
      statusColor = 'bg-orange-400'
      break
    default:
      statusColor = 'bg-gray-400'
  }

  return (
    <div
      className={
        `rounded-full ${statusColor} ${sizeClass}` +
        (className ? ` ${className}` : '')
      }
      hidden={hidden}
    />
  )
}

export default StatusBall
